import { Component, signal } from '@angular/core';



@Component({
  imports: [],
  templateUrl: './toast.toast.html',
  styleUrl: './toast.toast.scss'
})
export class ToastPage {
  message = signal<string>('');
}
